// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2RbvK","header":"Messages_header__1CHfP"};